import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, Home } from 'lucide-react';
import { Link } from 'react-router-dom';

export const NotFound = () => {
  return (
    <div className="w-full min-h-screen bg-gradient-to-br from-[#181C25] via-[#212635] to-[#181C25] text-white flex items-center justify-center px-4 lg:ml-16">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="text-center max-w-lg"
      >
        {/* Illustration 404 */}
        <motion.div
          animate={{ y: [0, -10, 0] }}
          transition={{ duration: 3, repeat: Infinity }}
          className="mb-12"
        >
          <div className="text-8xl font-montserrat font-bold mb-4">
            <span style={{ color: '#0090FF' }}>4</span>
            <span className="text-gray-500">0</span>
            <span style={{ color: '#0090FF' }}>4</span>
          </div>
        </motion.div>

        {/* Titre */}
        <h1 className="text-4xl lg:text-5xl font-montserrat font-bold mb-4">
          Page non trouvée
        </h1>

        {/* Description */}
        <p className="text-gray-400 text-lg mb-8 leading-relaxed">
          Oups ! La page que vous cherchez n'existe pas ou a été déplacée. Retournez à l'accueil pour continuer votre exploration.
        </p>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-gradient-to-r from-blue-500 to-blue-600 text-white font-semibold hover:shadow-lg hover:shadow-blue-500/50 transition-all w-full sm:w-auto justify-center"
            >
              <Home size={20} />
              Retour à l'accueil
            </motion.button>
          </Link>
          
          <a href="/?scroll=contact">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="inline-flex items-center gap-2 px-6 py-3 rounded-lg border border-gray-700 text-gray-300 font-semibold hover:border-blue-500 hover:text-blue-400 transition-all w-full sm:w-auto justify-center"
            >
              <ArrowLeft size={20} />
              Nous contacter
            </motion.button>
          </a>
        </div>

        {/* Background Elements */}
        <div className="absolute inset-0 -z-10 overflow-hidden pointer-events-none">
          <motion.div
            animate={{ opacity: [0.1, 0.3, 0.1] }}
            transition={{ duration: 3, repeat: Infinity }}
            className="absolute top-20 right-20 w-64 h-64 bg-blue-500/10 rounded-full blur-3xl"
          />
          <motion.div
            animate={{ opacity: [0.1, 0.3, 0.1] }}
            transition={{ duration: 3, repeat: Infinity, delay: 1 }}
            className="absolute bottom-20 left-20 w-64 h-64 bg-purple-500/10 rounded-full blur-3xl"
          />
        </div>
      </motion.div>
    </div>
  );
};

export default NotFound;
